import { Box, TableCell, TableRow as MuiTableRow, Tooltip, Typography, useTheme } from '@mui/material';

import { OpenInNewIcon } from 'icons';

export function TableRow({ title, value, link = null, testId = 'unknown' }) {
    return (
        <MuiTableRow>
            <TableCell component="th" scope="row" style={{ width: '350px' }}>
                {title}
            </TableCell>
            {link ? (
                <TableCell style={{ whiteSpace: 'break-spaces' }} data-testid={`LicenseFileDetailsRow_${testId}`}>
                    <LinkTo value={value} linkTo={link} />
                </TableCell>
            ) : (
                <TableCell style={{ whiteSpace: 'break-spaces' }} data-testid={`LicenseFileDetailsRow_${testId}`}>
                    {value}
                </TableCell>
            )}
        </MuiTableRow>
    );
}

function LinkTo({ value, linkTo }: { value: string; linkTo: string }) {
    const theme = useTheme();

    return (
        <Typography
            style={{ display: 'inherit', width: 'fit-content' }}
            color="primary"
            variant="body2"
            target="_blank"
            component="a"
            href={linkTo}
            rel="noopener noreferrer"
        >
            <Tooltip title="Open external link in a new tab" placement="bottom-start">
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: theme.spacing(1),
                    }}
                >
                    {value}
                    <OpenInNewIcon style={{ fontSize: 'inherit' }} />
                </Box>
            </Tooltip>
        </Typography>
    );
}
